import { connect } from 'react-redux';

import { openDrawer } from 'actions/drawer';
import { DRAWER_CREATE_UNICAST } from 'types/drawer';

import UnicastFeeds from 'components/LeftMenu/UnicastFeeds';
import  { selectors, actions } from '@amplement/backend-connector';
import { push } from 'redux-first-history';
import { getUrl } from 'utils/url';

const mapStateToProps = state => {
    const _feeds = selectors.feeds.getFeedsAcceptedUnicastIds(state);
    const isLoading = !selectors.feeds.getFeedsLoaded(state);
    const error = selectors.feeds.getFeedsError(state);

    return ({
        _feeds,
        isLoading,
        error
    });
};

const mapDispatchToProps = dispatch => ({
    deleteAnchor: _anchor => {
        dispatch(actions.feeds.requestDeleteAnchor(_anchor));
        dispatch(push(getUrl('dashboard')));
    },
    openCreateUnicastFeed: () => dispatch(openDrawer(DRAWER_CREATE_UNICAST))
});

export default connect(mapStateToProps, mapDispatchToProps)(UnicastFeeds);
